import { Form } from 'app/hooks/useGlobalForm';
import { cloneDeep } from 'lodash';
export const productFormaterForComparison = (products: Partial<Form>[]) => {
  const clonedProducts = cloneDeep(products);
  clonedProducts.forEach(prod => {
    prod.accessories?.accessories?.sort();
  });
  return clonedProducts;
};
